export default __webpack_public_path__ + "static/media/sun.fdb7d537.svg";